<div class="filter-chip">
	<span class="filter-chip__label">{{ label }}</span>

	<button
		*ngIf="removable"
		type="button"
		class="filter-chip__remove"
		[attr.aria-label]="removeAriaLabel"
		(click)="onRemove()"
	>
		<i class="fal fa-times"></i>
	</button>
</div>
